import { useEffect, useState } from "react";
import { NAME_COLORS } from "./nameCircle.constants";

const COLORS = ["#3CAE63", "#6D8196", "#FF7518", "#F1C338"];
const NameCircle = ({
  name,
  maxLength = 2,
  index = -1,
  greyScale = false,
  color = "",
  hasError = false,
  hasPhotos = false,
  onPhotosClick,
}: {
  name: string;
  maxLength?: number;
  index?: number;
  greyScale?: boolean;
  color?: string;
  hasError?: boolean;
  hasPhotos?: boolean;
  onPhotosClick?: () => void;
}) => {
  const [circleInfo, setCircleInfo] = useState({
    // color: greyScale ? "text-gray-700" : "text-white",
    // bgColor: "bg-orange-700",
    size: "w-8 h-8",
    bold: "font-bold",
  });

  const getDisplayName = (name: string) => {
    if (name) {
      return name
        .split(" ")
        .map((name) => name[0])
        .slice(0, maxLength)
        .join("")
        .toUpperCase();
    }
    return "";
  };

  // useEffect(() => {
  //   if (color !== "") {
  //     setCircleInfo({
  //       size: "w-10 h-10",
  //       bold: "font-semibold",
  //     });
  //   }
  // }, [color]);

  return (
    <>
      <div className="relative inline-block">
        {hasError && (
          <div className="absolute -left-3.5 top-1/2 -translate-y-1/2 w-2 h-2 bg-red-500 rounded-full"></div>
        )}
        {hasPhotos && (
          <div 
            className="absolute -inset-1 rounded-full border-2 border-blue-400 cursor-pointer hover:border-blue-500"
            onClick={(e) => {
              e.stopPropagation();
              onPhotosClick?.();
            }}
          ></div>
        )}
        <div
          className={`${Object.values(circleInfo).join(
            " "
          )} rounded-full flex items-center justify-center text-xs font-bold ${hasPhotos ? 'cursor-pointer' : ''}`}
          style={{
            backgroundColor: color
              ? `${color}40`
              : `${COLORS[Math.floor(Math.random() * COLORS.length)]}70`,
              textDecorationColor: color         
              ? `${color}90`
              : `${COLORS[Math.floor(Math.random() * COLORS.length)]}90`,
              color 
          }}
          onClick={hasPhotos ? (e) => {
            e.stopPropagation();
            onPhotosClick?.();
          } : undefined}
        >
          {getDisplayName(name)}
        </div>
      </div>
    </>
  );
};

export default NameCircle;
